const CustomFontsAPI = {
    /**
     * Returns a CSS file as a string to load a font for Partner-specific style customizations
     *
     * This is a function that utilizes the `fetch` API to retrieve a custom font's style sheet
     * via a url (location the font is hosted). This should be used only for loading style sheets
     * using the `@font-face` CSS at-rule.
     *
     * @function loadCustomFontCSS
     * @param {string} url - The url for the CSS file that loads the custom font.
     * @returns {string} The CSS file as a string
     * @example
     * const fontLink = 'https://somedomain.com/css/fonts/font-face.css'
     * const customFont = await CustomFontsAPI.loadCustomFontCSS(fontLink);
     */
    async loadCustomFontCSS(url) {
        const response = await fetch(url, {
            method: 'GET',
            headers: {
                'Content-Type': 'text/css; charset=UTF-8',
            },
        })
            .then(res => res.text())
            .catch(err => {
                // eslint-disable-next-line no-console
                console.error(err);
            });

        return response;
    },
};

export default CustomFontsAPI;
